import { createNamespace } from '../../utils'; // Components

var _createNamespace = createNamespace('prescription'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: Number,
      default: 1
    }
  },
  computed: {
    showDoctorSign: function showDoctorSign() {
      var _this$detail = this.detail,
          advisoryType = _this$detail.advisoryType,
          serviceAuditStatus = _this$detail.serviceAuditStatus,
          doctorAuditStatus = _this$detail.doctorAuditStatus; // 直接咨询和图文咨询,客服医生通过审核

      if ((advisoryType === 1 || advisoryType === 2) && serviceAuditStatus === 1) return true; // 视频咨询,医生审核通过

      return advisoryType === 4 && doctorAuditStatus === 1;
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    usage: function usage(item, type) {
      var _item$usage = item.usage,
          usage = _item$usage === void 0 ? '' : _item$usage,
          perNum = item.perNum,
          perUnit = item.perUnit,
          _item$usageFrequencyN = item.usageFrequencyName,
          usageFrequencyName = _item$usageFrequencyN === void 0 ? '' : _item$usageFrequencyN;
      var _item$dose = item.dose,
          dose = _item$dose === void 0 ? '' : _item$dose;

      if (type === 2) {
        if (!usage || !perNum || !perUnit || !usageFrequencyName || !dose) return '待补充';
      }

      var perAmount = '';
      if (perNum && perUnit && perUnit !== '无') perAmount = perNum + perUnit + '/次';
      if (perNum && (!perUnit || perUnit === '无')) perAmount = perNum + '/次';
      dose = dose ? '用药' + dose + '天' : '';
      return usage + ' ' + perAmount + ' ' + usageFrequencyName + ' ' + dose;
    },
    drugNum: function drugNum(item) {
      var num = item.num,
          unit = item.unit;
      if (!unit) return '待补充';
      var temp = parseInt(num, 10);

      if (isNaN(temp) || temp < 0) {
        return '';
      }

      return "" + num + unit;
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var _this$detail2 = this.detail,
        prescriptionType = _this$detail2.prescriptionType,
        prescriptionDetails = _this$detail2.prescriptionDetails,
        prescriptionTotalStatus = _this$detail2.prescriptionTotalStatus,
        supplementaryNotes = _this$detail2.supplementaryNotes,
        chineseMedicineDetail = _this$detail2.chineseMedicineDetail,
        type = this.type;
    return h("div", {
      "class": bem('drug-info')
    }, [h("p", {
      "class": bem('drug-info--title')
    }, ["Rp."]), prescriptionType === 1 ? h("div", {
      "class": bem('drug-info-chinese--wrap')
    }, [h("ul", {
      "class": bem('drug-info-chinese--list')
    }, [prescriptionDetails.map(function (detail, i) {
      return h("li", {
        "class": bem('drug-info-chinese--item'),
        "key": i
      }, [h("span", {
        "class": bem('drug-info-chinese--drug-name')
      }, [detail.name, detail.usage && h("span", {
        "class": bem('drug-info-chinese--drug-usage')
      }, ["\uFF08", detail.usage, "\uFF09"])]), detail.perNum, detail.perUnit]);
    })]), h("div", {
      "class": bem('drug-info-chinese--usage')
    }, [h("h2", {
      "class": bem('drug-info-chinese--usage-title')
    }, ["\u7528\u6CD5\u7528\u91CF"]), h("p", {
      "class": bem('drug-info-chinese--usage-item')
    }, ["\u5171", chineseMedicineDetail.usageNum, "\u5242\uFF0C\u6BCF\u65E5", chineseMedicineDetail.usageFrequency, "\u5242\uFF0C\u6BCF\u5242\u5206", chineseMedicineDetail.usagePerNum, "\u6B21\u4F7F\u7528"]), h("p", {
      "class": bem('drug-info-chinese--usage-item')
    }, ["\u7528\u836F\u65B9\u5F0F\uFF1A", chineseMedicineDetail.usageWay]), chineseMedicineDetail.usageTime && h("p", {
      "class": bem('drug-info-chinese--usage-item')
    }, ["\u7528\u836F\u65F6\u95F4\uFF1A", chineseMedicineDetail.usageTime])])]) : h("ul", {
      "class": bem('drug-info--list')
    }, [prescriptionDetails && prescriptionDetails.map(function (item) {
      return h("li", {
        "class": bem('drug-info--item')
      }, [h("h3", [item.chemicalName || item.drugName || item.name || '', item.spec, " \u3010", _this.drugNum(item), "\u3011"]), h("p", {
        "class": bem('drug-info--usage')
      }, ["\u7528\u6CD5: ", _this.usage(item, type)]), prescriptionTotalStatus === 1 ? h("p", {
        "class": bem('drug-info--remark')
      }, ["\u5907\u6CE8: ", item.remark || '无']) : '']);
    })]), supplementaryNotes ? h("div", {
      "class": bem('drug-info--supplementary-notes')
    }, ["\u8865\u5145\u8BF4\u660E\uFF1A", supplementaryNotes]) : '', h("div", {
      "class": bem('drug-info--finish')
    }, ["\u4EE5\u4E0B\u7A7A\u767D"])]);
  }
});